var _path, _g, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUsdc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5397_207346)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5397_207346",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.10352e-05H20V20H0V6.10352e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5397_207346)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6.10352e-05C15.523 6.10352e-05 20 4.47711 20 10.0001C20 15.5226 15.523 20.0001 10 20.0001C4.47705 20.0001 0 15.5226 0 10.0001C0 4.47711 4.47705 6.10352e-05 10 6.10352e-05Z",
    fill: "#2775CA"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12592 16.9535C8.12592 17.1888 7.94172 17.3224 7.71422 17.2514C4.69069 16.2868 2.49854 13.4517 2.49854 10.1065C2.49854 6.76139 4.69069 3.92616 7.71422 2.96162C7.94172 2.89105 8.12592 3.02423 8.12592 3.25946V3.84014C8.12592 3.99673 8.00456 4.18105 7.85535 4.23207C5.46319 5.11048 3.74956 7.40855 3.74956 10.1025C3.74956 12.7965 5.46319 15.095 7.85535 15.973C8.00456 16.028 8.12592 16.2082 8.12592 16.3654V16.9535Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6238 14.7919C10.6238 14.9646 10.4826 15.1057 10.3101 15.1057H9.68649C9.51399 15.1057 9.37285 14.9646 9.37285 14.7919V13.8038C8.00808 13.6196 7.3416 12.8547 7.16115 11.8156C7.12967 11.6389 7.27081 11.4782 7.45126 11.4782H8.16501C8.31399 11.4782 8.43956 11.5842 8.47092 11.733C8.60433 12.3527 8.96115 12.8272 10.0551 12.8272C10.863 12.8272 11.4357 12.3762 11.4357 11.702C11.4357 11.0272 11.0983 10.7724 9.91399 10.5762C8.16501 10.341 7.33763 9.81141 7.33763 8.43891C7.33763 7.38016 8.13774 6.55675 9.37683 6.38016V5.41152C9.37683 5.23891 9.51808 5.09766 9.69047 5.09766H10.3141C10.4866 5.09766 10.6277 5.23891 10.6277 5.41152V6.40766C11.6356 6.58834 12.2748 7.1605 12.4827 8.10947C12.5218 8.29016 12.3807 8.45845 12.1965 8.45845H11.5375C11.3964 8.45845 11.2788 8.36425 11.2357 8.22709C11.0592 7.62345 10.6277 7.3647 9.87865 7.3647C9.05126 7.3647 8.62376 7.76459 8.62376 8.32527C8.62376 8.91743 8.86706 9.21527 10.1377 9.39993C11.8551 9.63516 12.7416 10.1253 12.7416 11.5883C12.7416 12.698 11.918 13.5961 10.6277 13.8038V14.7919H10.6238Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2867 17.2516C12.0594 17.3227 11.875 17.189 11.875 16.9538V16.3736C11.875 16.201 11.9809 16.0403 12.1456 15.9812C14.5377 15.1028 16.2514 12.8047 16.2514 10.1107C16.2514 7.41675 14.5377 5.11868 12.1456 4.24028C11.9966 4.18528 11.875 4.00505 11.875 3.84789V3.26766C11.875 3.03243 12.0594 2.89527 12.2867 2.96937C15.3102 3.93448 17.5024 6.76959 17.5024 10.1147C17.4986 13.4519 15.3102 16.2831 12.2867 17.2516Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5397_207346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsdc);
export default __webpack_public_path__ + "static/media/ICON_USDC.f498c9ae79a8e0f0a0e0a9da12007a19.svg";
export { ForwardRef as ReactComponent };